<template>
    <div class="regular-line-table">
        <div class="title-container">
            <span class="sub-title">{{ title }}</span>
            <i :class="contentVisible ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" @click="handleCollapse"></i>
        </div>
        <div v-show="contentVisible">
            <el-table v-loading="loading" :data="tableData" border style="width: 100%" max-height="400px">
                <el-table-column label="始发地档口图片" width="130">
                    <template slot-scope="{ row }">
                        <el-button
                            v-if="(row.originDoorFileList && row.originDoorFileList.length) || (row.originOperateFileList && row.originOperateFileList.length)"
                            type="text"
                            @click="preview(row, 'originDoorFileList', 'originOperateFileList')">
                            查看
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column label="目的地档口图片" width="130">
                    <template slot-scope="{ row }">
                        <el-button
                            v-if="(row.destinationDoorFileList && row.destinationDoorFileList.length) || (row.destinationOperateFileList && row.destinationOperateFileList.length)"
                            type="text"
                            @click="preview(row, 'destinationDoorFileList', 'destinationOperateFileList')">
                            查看
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="routeType" label="线路类型" width="100"></el-table-column>
                <el-table-column prop="isSelfManage_" label="是否零担自营线路" width="150"></el-table-column>
                <el-table-column prop="originArea" label="线路始发省市区" width="180"></el-table-column>
                <el-table-column prop="originStationName" label="始发地货站名称" width="180"></el-table-column>
                <el-table-column prop="originAddress" label="始发地档口详细地址"></el-table-column>
                <el-table-column prop="destinationArea" label="线路目的省市区" width="180"></el-table-column>
                <el-table-column prop="destinationStationName" label="目的地货站名称" width="180"></el-table-column>
                <el-table-column prop="destinationAddress" label="目的地档口详细地址"></el-table-column>
            </el-table>
            <el-pagination
                class="pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[10, 20, 30, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"></el-pagination>
        </div>

        <preview
            :attachmentList="attachmentList"
            v-if="attachmentShow"
            :attachmentShow.sync="attachmentShow"
            :rowData="rowData"></preview>
    </div>
</template>
<script>
import preview from '../../../../../../components/viewAttachment.vue'
import { supplierCommonRoutePage } from '../../../../../../api/regularRoute.js'
import { dictWithUrl } from '@/components/lots/api'

export default {
    components: { preview },
    props: {
        auditId: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        supplierCode: {
            type: String,
            default: '',
        },
        ids: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            loading: false,
            contentVisible: true,
            tableData: [],
            attachmentList: [],
            attachmentShow: false,
            rowData: {},
            pageNo: 1,
            pageSize: 10,
            total: 0,
            dict: {},
        }
    },
    methods: {
        handleCurrentChange(v) {
            this.pageNo = v
            this.getList()
        },
        handleSizeChange(v) {
            this.pageSize = v
            this.pageNo = 1
            this.getList()
        },
        handleCollapse() {
            this.contentVisible = !this.contentVisible
        },
        preview(row, prop1, prop2) {
            let downUrl = '', fileName = ''
            if(row[prop1] && row[prop1][0]){
                downUrl = row[prop1][0].fileUrl
                fileName = row[prop1][0].fileName
            }else if (row[prop2] && row[prop2][0]){
                downUrl = row[prop2][0].fileUrl
                fileName = row[prop2][0].fileName
            }
            this.rowData = {
                downUrl,
                fileName,
                // fileId: row[prop1][0].fileId,
            }
            this.attachmentList = [...(row[prop1] || []), ...(row[prop2] || [])].map(v => v.fileUrl)
            this.attachmentShow = true
        },
        getList() {
            this.loading = true
            supplierCommonRoutePage({
                fdId: this.auditId,
                supplierCode: this.supplierCode,
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                orderBy: 'is_self_manage',
                orderByType: 'desc',
                ids: this.ids ? this.ids.split(',') : null,
            })
                .then(res => {
                    if (res && +res.code === 0) {
                        this.total = res.data.totalCount || 0
                        this.tableData = (res.data.list || []).map(v => {
                            return {
                                ...v,
                                isSelfManage_: this.dict['SRM_YES_NO'][v.isSelfManage],
                                originArea: `${v.originProvName}${v.originCityName ? `-${v.originCityName}` : ''}${
                                    v.originCountyName ? `-${v.originCountyName}` : ''
                                }`,
                                destinationArea: `${v.destinationProvName}${
                                    v.destinationCityName ? `-${v.destinationCityName}` : ''
                                }${v.destinationCountyName ? `-${v.destinationCountyName}` : ''}`,
                            }
                        })
                        //列表有值时默认展开
                        this.contentVisible = !!this.tableData.length
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
    },
    mounted() {
        dictWithUrl('SRM_YES_NO').then(res => {
            this.dict = res.data
            this.getList()
        })
    },
}
</script>
<style lang="less" scoped>
.regular-line-table {
    .title-container {
        margin-bottom: 10px;

        i {
            float: right;
            padding-right: 10px;
            font-size: 24px;
            cursor: pointer;
        }
    }
    .sub-title {
        display: inline-block;
        font-weight: bold;
        font-size: 14px;

        &::before {
            display: inline-block;
            // border-radius: 50%;
            margin-right: 5px;
            width: 5px;
            height: 14px;
            background: #000;
            content: '';
            vertical-align: middle;
        }
    }
    .pagination {
        text-align: right;
        margin-top: 10px;
    }
}
</style>
